<div class="m-2 p-2 item-container" [ngClass]="{selected: !!selectedToken && selectedToken === cc.token}">
  <div class="left-section">
    <img [src]="cc.imageUrl" height="24px" [alt]="cc.cardType"/>
  </div>

  <div class="right-section">
    <div class="type">{{ cc.cardType }}</div>
    <div>ending in ...<span class="bold">{{ cc.last4 }}</span></div>
    <div>Expires: <span class="bold">{{cc.expirationDate}}</span></div>
  </div>

</div>

